<template>
    <div>

        <headroom
            v-if="routePartialType === 'full'"
            :upTolerance="20"
            :downTolerance="20"
        >
            <b-navbar toggleable="lg" type="light" class="full-navbar" >
                <div class="container">

                    <b-navbar-brand :to="{name: 'home'}">
                        <img src="@/assets/images/main/lockup.png">
                    </b-navbar-brand>

                    <b-navbar-toggle target="nav_collapse">
                        <img src="@/assets/images/utilities/collapse-button-black.png" alt="Menu">
                    </b-navbar-toggle>

                    <b-collapse is-nav id="nav_collapse">
                        <b-navbar-nav>
                            <b-nav-item href="https://blog.bestmeta.com" target="_blank">
                                Vist the Blog
                            </b-nav-item>
                        </b-navbar-nav>

                        <b-navbar-nav>
                            <b-nav-item :to="{name: 'about'}">
                                (Info Circle)
                                What is Best Meta
                            </b-nav-item>
                        </b-navbar-nav>

                        <!-- <b-navbar-nav v-if="!user" class="ml-auto">
                            <b-nav-item  class="b-nav-item-button b-nav-item-button--purple my-2 my-lg-0 mr-lg-2" :to="{name: 'signup'}">
                                Signup
                            </b-nav-item>

                            <b-nav-item  class="b-nav-item-button b-nav-item-button--orange my-2 my-lg-0 mr-lg-2" :to="{name: 'login'}">
                                Login
                            </b-nav-item>
                        </b-navbar-nav> -->

                        <!-- Logged In -->
                        <!-- <b-navbar-nav v-if="user" class="ml-auto">
                            <b-nav-item-dropdown right>
                                <template slot="button-content">
                                    <img src="@/assets/images/utilities/user-account-picture.png" alt="Menu">
                                </template>

                                <b-dropdown-item disabled>Signed in as <br> {{user.username}}</b-dropdown-item>
                                <b-dropdown-divider></b-dropdown-divider>

                                <b-dropdown-item :to="{name: 'dashboard'}">(Thumbtack)  Dashboard</b-dropdown-item>
                                <b-dropdown-item v-on:click.prevent="logout()">(Sign out) Logout</b-dropdown-item>
                            </b-nav-item-dropdown>
                        </b-navbar-nav> -->

                    </b-collapse>
                </div>
            </b-navbar>
        </headroom>

        <div v-if="routePartialType === 'account' && user">
            <div class="imd-navbar">
                <div class="imd-navbar__collapse-button" v-on:click="showUndernav = !showUndernav">
                    <img src="@/assets/images/utilities/collapse-button-black.png" alt="Menu">
                </div>

                <div class="imd-navbar__brand ml-2">
                    <router-link :to="{name: 'dashboard'}">
                        <img src="@/assets/images/main/lockup.png">
                    </router-link>
                </div>

                <div class="imd-navbar__user-account-button">

                    <b-dropdown id="user-account-dropdown-button" right variant="custom-navbar-dropdown-black">
                        <template slot="button-content">
                            <img src="@/assets/images/utilities/user-account-picture.png" alt="Menu">
                        </template>

                        <b-dropdown-item disabled>Signed in as <br> {{user.username}}</b-dropdown-item>
                        <b-dropdown-divider></b-dropdown-divider>

                        <b-dropdown-item href :to="{name: 'dashboard'}">(Thumbtack) Dashboard</b-dropdown-item>
                        <b-dropdown-item href :to="{name: 'home'}" exact>(Home) App Home Page</b-dropdown-item>
                        <b-dropdown-item href v-on:click.prevent="logout()">(Sign out) Logout</b-dropdown-item>
                    </b-dropdown>

                </div>
            </div>
        </div>

        <div v-if="routePartialType === 'account' && user && showUndernav" class="imd-undernav">
            <router-link :to="{name: 'dashboard'}" class="imd-undernav__item">(Thumbtack)  Dashboard</router-link>

            <router-link :to="{name: 'home'}" class="imd-undernav__item">(Search) Search</router-link>

            <!-- <router-link :to="{name: 'preferences'}" class="imd-undernav__item"><font-awesome-icon :icon="['fal', 'cog']" class="fa fa-fw" /> Preferences</router-link> -->
        </div>

    </div>
</template>

<script>
import { mapGetters } from 'vuex'
/* eslint-disable-next-line no-unused-vars  */
import { headroom } from 'vue-headroom'
// headroom.computed.style = () => ''

export default {
    name: 'navbar',
    data () {
        return {
            // Decide to show based on the window's initial width
            showUndernav: (window.innerWidth > 992)
        }
    },
    methods: {
        async logout () {
            // As you can see, with Vuex we we need to fire logout methods
            // for each of our modules.
            await this.$store.dispatch('user/userLogout')
            this.$router.push({name: 'home'})

            // After logging the user out we need to refresh the page
            // this is because some of our components initialize on their
            // created methods - and when a user logs out they need to be
            // fully cleared.
            // location.reload()
            document.location.href = '/'
        }
    },
    computed: {
        ...mapGetters({
            user: 'user/user'
        }),
        routePartialType () {
            return this.$route.meta.partialType
        }
    },
    components: {
        headroom
    }
}
</script>

<style lang="scss" scoped>
    @import '~@/assets/css/components/_variables.scss';

    .full-navbar {
        background: $white;
        border-bottom: $border;

        // navbar is x tall - only needed with fixed nav
        // connection in main css
        min-height: 58px;

        .navbar {
            padding-left: 0;
            padding-right: 0;
        }

        .navbar-brand {
            margin-top: -5px;
        }

        img {
            max-height: 20px;
        }

        // Have to use this because nav-link's only
        // close the nav menu when they're wrapped using b-nav-item
        // in bootstrap-vue
        .b-nav-item-button {
            .nav-link {
                color: $white;
                text-transform: uppercase;
                letter-spacing: 1px;
                display: inline-block;
                font-weight: 400;
                text-align: center;
                white-space: nowrap;
                vertical-align: middle;
                user-select: none;
                border: 1px solid transparent;
                padding: 0.375rem 0.75rem;
                font-size: 1rem;
                line-height: 1.5;
                border-radius: 0.25rem;
                padding: 0.25rem 0.5rem;
                font-size: 0.875rem;
                line-height: 1.5;
                border-radius: 0.2rem;
                color: $white;
                background-color: $grey;
                border-color: $grey;

                &:hover {
                    box-shadow: 0 7px 14px rgba(50,50,93,.1), 0 3px 6px rgba(0,0,0,.03);
                }
            }

            &--purple {
                .nav-link {
                    color: $white;
                    background-color: $purple;
                    border-color: $purple;

                    &:hover {
                        background-color: darken($purple, 10%);
                        color: $white;
                    }

                    &.active {
                        color: $white;
                        background-color: darken($purple, 10%);
                    }
                }
            }

            &--orange {
                .nav-link {
                    color: $white;
                    background-color: $orange;
                    border-color: $orange;

                    &:hover {
                        background-color: darken($orange, 10%);
                        color: $white;
                    }

                    &.active {
                        color: $white;
                        background-color: darken($orange, 10%);
                    }
                }
            }
        }
    }

    .imd-navbar {
        height: 56px;
        max-width: 1800px;
        margin-left: auto;
        margin-right: auto;
        background: $white;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;

        &__collapse-button {
            padding-left: 15px;

            &:hover {
                cursor: pointer;
            }

            @media (min-width:992px) {
                display: none;
            }

            img {
                max-height: 35px;
            }
        }

        &__brand {
            color: $white;
            font-size: 1.8rem;
            font-weight: bold;

            a {
                &:hover {
                    text-decoration: none;
                }
            }

            img {
                margin-top: -5px;
                max-height: 20px;
            }

            &__content {
                color: $white;

                .yellow-text {
                    color: $yellow;
                }

                &:hover {
                    text-decoration: none;
                }

                &--small {
                    display: block;
                    padding-left: 25px;
                    @media (min-width:992px) {
                        display: none;
                    }
                }

                &--large {
                    display: none;
                    @media (min-width:992px) {
                        display: block;
                        padding-left: 15px;
                    }
                }
            }
        }

        &__user-account-button {

            @media (min-width: 992px) {
                padding-right: 10px;
            }

            img {
                max-height: 35px;
            }
        }
    }

    .imd-undernav {
        padding: 20px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        height: auto;
        background: $light-grey;
        font-size: 1.2rem;

        @media (min-width: 992px) {
            padding: 0;
            display: flex;
            flex-direction: row;
            align-items: baseline;
            height: auto;
            background: $light-grey;
            font-size: 1.2rem;
        }

        &__item {
            margin-bottom: 10px;
            color: $font-color;

            &:hover {
                text-decoration: none;
                color: $blue;
            }

            @media (min-width:992px) {
                margin-bottom: 0;
                transition: $transition;
                padding: 20px;

                &:hover {
                    color: $font-color;
                    background-color: darken($light-grey, 10%);
                }
            }
        }
    }
</style>
